import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(4),
  },

  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },

  amount: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 600,
  },

  amountUsd: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
    fontSize: theme.typography.pxToRem(12),
  },
}));
